import 'Generic/styles/style.css';
import './styles/style.css';
import './styles/proPlan.css';
import './styles/checkout.css';
import 'Generic/styles/products-info-modals-v2.css';
import 'Generic/styles/dedicated-popup.css';
import {store, setState, fieldsValidation, GpayGateway, ApplePayGateway, constant} from 'Generic';
import PackageBoxes from './components/packageBoxes';
import Gateways from './components/gateways';
import Addons from './components/addons';
import OrderSummary from './components/orderSummary';
import CheckoutForm from './components/checkoutForm';
import Incentive from './components/incentive';
import GatewayIncentive from './components/gatewayIncentive';
import PlanBoxes from 'Generic/lib/components/PlanBoxes';
import PopularAddons from './components/popularAddons';
import {
  getGpayOnGatewayChange,
  addAddon,
  selectPlan,
  removeAddon,
  applyCouponCode,
  removeCouponCode,
  showCouponResponcse,
  splitIntoFirstAndSecondName,
  openAddonsCountryPopup,
  openAddonsCountryCitiesPopup,
  openAddonsMultiLoginPopup,
  selectGateway,
  removeInputError,
  getSelectedGatewayOnLoad,
  removeClass,
  sendGa4EcommerceEvent,
  GA4addPaymentInfoEvent,
  sendGa4CustomEvent,
  gmailDomainCorrection,
  openCustomModal,
  closeCustomPopup,
  openAddonsResidentNetworkPopup,
} from 'Generic/lib';
import 'Generic/lib/tweet';
import 'Generic/styles/resident-network-popup.css';

/* Setting Global Variables */
window.base_url = window.location.origin;
window.conditionalGateways = {
  applepay: false,
  gatepay:
    (/android/i.test(navigator.userAgent) && 'gateio' in window) || //to show gatepay in android app
    (['iPad', 'iPhone'].includes(navigator?.userAgentData?.platform || navigator?.platform) &&
      typeof window.webkit?.messageHandlers?.gatepay === 'object'), //to show gatepay in iOS opp
};
window.applePay = {};
window.renderComponents = renderComponents;

/* Cart State */
let cartState = store.state.cartState ? store.state.cartState : {};

/* Parsing cart params data */
let keysToBeParsed = [
  'plans',
  'plans_currency',
  'old_prices',
  'special_addons_old_prices',
  'gateway_incentives',
  'hidden_packages',
  'hidden_packages_currency',
  'hidden_products_association',
];
let parsedData = {};
keysToBeParsed.map(key => {
  let stateData = cartState[key];
  if (stateData) {
    parsedData = {...parsedData, [key]: JSON.parse(stateData)};
  }
});
setState(parsedData);

/* Setting usefull data in variables to reuse */
let selectedPlanIndex = cartState.selected_package_index ? cartState.selected_package_index : 1;
let selectedPlan = cartState.plans[selectedPlanIndex] ? cartState.plans[selectedPlanIndex] : {};
selectPlan(selectedPlanIndex);

/* Adding selected gateway in state */
if (cartState) {
  let selectedGateway = getSelectedGatewayOnLoad();
  if (selectedGateway.gateway_key) {
    setState({
      selected_gateway: selectedGateway.gateway_key,
      selected_gateway_name: selectedGateway.gateway_name,
    });
  }
}

/* Cart package boxes select event */
document.querySelectorAll('.cart-box').forEach((cartBox, index) => {
  cartBox.addEventListener('click', () => {
    let newSelectedPlan = cartState.plans[index] ? cartState.plans[index] : {};

    if (newSelectedPlan.code !== cartState.selected_plan.code) {
      selectPlan(index);
    }

    showVpnStripe();
  });
});

/* Cart gateway select event */
let gatewaysWrapper = document.querySelector('#payment_gateways');
let incentiveElement = document.querySelector('#hidden-product-wrapper');
gatewaysWrapper?.addEventListener('click', function (e) {
  let target = e.target;
  if (target.matches('.payment_selection_box, .payment_selection_box *')) {
    e.stopPropagation();

    let gatewayKey = target.getAttribute('data-name');
    let gatewayName = target.getAttribute('data-gateway-text');
    if (!gatewayKey) {
      gatewayKey = target.closest('.payment_selection_box').getAttribute('data-name');
      gatewayName = target.closest('.payment_selection_box').getAttribute('data-gateway-text');
    }
    if (incentiveElement) {
      incentiveElement.style.display = 'none';
    }
    selectGateway(gatewayKey, gatewayName);
    getGpayOnGatewayChange(gatewayKey, GatewaysInstance);
  }
});

let gatewaysMobileWrapper = document.querySelector('.payments-select-box');
gatewaysMobileWrapper?.addEventListener('change', function (e) {
  let target = e.target;
  let selectedElement = target.options[target.selectedIndex];
  let gatewayKey = selectedElement.getAttribute('data-name');
  if (incentiveElement) {
    incentiveElement.style.display = 'none';
  }
  let gatewayName = selectedElement.getAttribute('data-gateway-text');
  selectGateway(gatewayKey, gatewayName);
  getGpayOnGatewayChange(gatewayKey, GatewaysInstance);
});

/* Coupon Events */
let couponToggle = document.getElementById('coupon-toggle');
couponToggle.addEventListener('click', () => {
  document.querySelector('.payment-coupon-box').classList.toggle('active');
  document.querySelector('#coupon-input').focus();
});

function applyCouponSubmit() {
  let couponInputValue = document.querySelector('#coupon-input').value;
  if (couponInputValue !== '') {
    if (!couponInputValue.includes('fpdr')) {
      applyCouponCode(couponInputValue);
    } else {
      showCouponResponcse(false);
    }
  }
}

let couponSubmitButton = document.getElementById('coupon-submit');
couponSubmitButton.addEventListener('click', applyCouponSubmit);

let couponRemoveButton = document.querySelector('.payment-coupon-cancel');
couponRemoveButton.addEventListener('click', removeCouponCode);

let couponInputField = document.querySelector('#coupon-input');
couponInputField.addEventListener('focusout', e => {
  let couponValue = e.target.value;
  if (!couponValue) removeCouponCode();
});

couponInputField.addEventListener('keypress', e => {
  if (e.which == 13) {
    e.preventDefault();
    applyCouponSubmit();
  }
});

/* Show password event */
let showPasswordButton = document.querySelector('.password-eye-icon');
showPasswordButton.addEventListener('click', () => {
  let passwordInputField = document.querySelector('#input_password');
  let type = passwordInputField.type === 'text' ? 'password' : 'text';

  passwordInputField.type = type;
});

/* Addon select event */
document.addEventListener('click', function (e) {
  let target = e.target;
  let popupCheck = false;
  let rangeClick = false;

  /* Addon information popup button click listener */
  if (target.matches('.popup_link, .popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let addonCode = target.getAttribute('addon-code');

    if (!addonCode) {
      addonCode = target.closest('.popup_link').getAttribute('addon-code');
    }

    let addonHttml = document.querySelector(`#${addonCode}_info_popup`);

    const modalId = `customcartPopup_${addonCode}`;

    let modalHtmlContent = addonHttml.innerHTML;

    openCustomModal(modalHtmlContent, modalId, 'modalAddonInfoClass');
  }

  if (!rangeClick) {
    /* Addon add button click listner */
    if (target.matches('.addon-btn, .addon-btn *') && !target.matches('.remove-btn, .remove-btn *, .unselect-box, .unselect-box *') && !popupCheck) {
      e.stopPropagation();
      closeCustomPopup();

      const addonBtn = target.closest('.addon-btn');
      let addonCode = addonBtn.getAttribute('addon-code');

      if (!addonCode) {
        target = target.closest('.addon-btn');
        addonCode = target.closest('.addon-btn').getAttribute('addon-code');
      }

      if (target.getAttribute('disabled') == 'disabled' || target.classList.contains('disabled-box')) return;

      if (addonCode === 'residential_network_bandwidth' && !cartState?.selected_addons?.includes(addonCode)) {
        openAddonsResidentNetworkPopup(addonCode);
        return;
      }

      if (addonCode === 'multi_login_limit' && !cartState?.selected_addons?.includes(addonCode)) {
        openAddonsMultiLoginPopup(addonCode);
        return;
      }

      if (addonCode === 'dedicated_server' && !cartState?.selected_addons?.includes(addonCode)) {
        openAddonsCountryCitiesPopup(addonCode);
        return;
      }

      if (constant.addonWithCountries.includes(addonCode) && !cartState?.selected_addons?.includes(addonCode)) {
        openAddonsCountryPopup(addonCode, () => {
          const popularAddonBox = document.querySelector('#popular-addons-box');
          const originType = addonBtn.getAttribute('data-origin');

          if (originType !== 'popular-addons' && popularAddonBox) {
            popularAddonBox?.classList.remove('active');
          }
        });
        return;
      }
      addAddon(addonCode);
    }

    /* Addon remove button click listner */
    if (target.matches('.remove-btn, .remove-btn *, .unselect-box, .unselect-box *') && !popupCheck) {
      e.stopPropagation();

      let addonCode = target.getAttribute('addon-code');
      if (!addonCode) {
        addonCode = target.closest('.addon-btn').getAttribute('addon-code');
      }

      const popularAddonBox = document.querySelector('#popular-addons-box');
      if (popularAddonBox) popularAddonBox.classList.add('active');

      removeAddon(addonCode);
    }
  }
});

/* Pre select addon logic */
const {addons: selectedPlanAddons} = selectedPlan;
const {pre_selected_addon: preSelectedAddon} = cartState;

for (let addon of selectedPlanAddons) {
  /* Normal addons */
  if (!constant.specialAddonList.includes(addon.code) && addon.code === preSelectedAddon) {
    /* If addon has country */
    if (constant.addonWithCountries.includes(addon.code)) {
      if (constant.addonsCountryList[addon.code]) {
        /* Generating country list HTML */
        const countries = constant.addonsCountryList[addon.code].reduce((acc, country) => {
          return acc + `<li class="icons-img ${country.code.toLowerCase()}-icon" data-country="${country.code}">${country.name}</li>`;
        }, '');

        /* appending country list HTML into country select box */
        const countryDropdownelement = document.querySelectorAll('.cart-box .dropdown-list');
        for (var i = 0; i < countryDropdownelement.length; i++) {
          countryDropdownelement[i].querySelector('.select-option-card ul').innerHTML = countries;
          countryDropdownelement[i].style.display = 'block';
          countryDropdownelement[i].setAttribute('addon-code', addon.code);
        }

        addAddon(addon.code, null, true);
      }
    } else {
      addAddon(addon.code);
    }
  }
}

document.addEventListener(
  'click',
  function (e) {
    let target = e.target;
    let dropdownListelement = target.closest('.dropdown-list');
    let selectedAddons = cartState.selected_addons ? cartState.selected_addons : [];

    removeClass('.dropdown-list', 'open');

    /* Addon add button click listner */
    if (target.matches('.selected-option, .selected-option *')) {
      e.stopPropagation();

      dropdownListelement.classList.add('open');
    }

    /* country click listner */
    if (target.matches('.icons-img, .icons-img *')) {
      e.stopPropagation();
      const addonCode = dropdownListelement.getAttribute('addon-code');
      const addonCountry = target.getAttribute('data-country');

      const countryDropdownelement = document.querySelectorAll('.country-select-op');
      for (var i = 0; i < countryDropdownelement.length; i++) {
        countryDropdownelement[i].innerText = target.innerText;
      }

      if (selectedAddons.includes(addonCode)) {
        removeAddon(addonCode);
      }

      addAddon(addonCode, addonCountry);
    }
  },
  true,
);

// Cities Accordian
document.addEventListener(
  'click',
  function (e) {
    let target = e?.target;
    let countryListTarget = target?.closest('.country-list');
    let cityList = document?.querySelectorAll('.city-list') || [];
    let currentCity = countryListTarget?.querySelector('.city-list');
    for (var i = 0; i < cityList.length; i++) {
      cityList[i].style.display = 'none';
    }
    if (currentCity) {
      currentCity.style.display = 'block';
    }
  },
  true,
);

/* User information input fields */
let paymentForm = document.querySelector('#payment-form');
paymentForm.addEventListener('keyup', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password')) {
    if (target.value) {
      fieldsValidation(target);
    }

    removeInputError(target);
  }
});

paymentForm.addEventListener('focusout', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password') && target.value) {
    const isValid = fieldsValidation(target);
    if (target.matches('#input_email') && isValid) {
      let correctDomain = gmailDomainCorrection(target.value);
      if (correctDomain) {
        target.value = correctDomain;
      }
    }
    if (window.isPaymentInfoEventSent === false && target.matches('#input_email') && isValid) {
      //send payment info event into GA4
      sendGa4CustomEvent('signup_email_push', {email: target.value});
      GA4addPaymentInfoEvent();
    }
  }

  if (target.matches('#input_name')) {
    let recurlyFirstNameElement = document.querySelector('[data-recurly="first_name"]');
    let recurlyLastNameElement = document.querySelector('[data-recurly="last_name"]');
    const [firstName, lastName] = splitIntoFirstAndSecondName(target.value);

    recurlyFirstNameElement.value = firstName || 'N/A';
    recurlyLastNameElement.value = lastName || 'N/A';
  }
});

/* VAT events */
const allCountries = cartState.all_countries ? cartState.all_countries : [];
const gatewayTaxSummary = document.querySelector('.tax-summary');
const taxSelected = document.querySelector('.tax-selected');
const optionsContainer = document.querySelector('.options-container');
const taxSelectbox = document.querySelector('.tax-selectbox');
const countrySearch = document.querySelector('#country-search');
const selectedCountryHiddenField = $("input[data-recurly='country']");
let selectedOption = document.querySelector('.country-option.option-selected .radio');

if (gatewayTaxSummary) {
  taxSelected.addEventListener('click', e => {
    e.stopPropagation();
    taxSelectbox.classList.toggle('active');
    countrySearch.focus();
  });

  document.addEventListener('click', e => {
    if (e.target !== countrySearch) {
      taxSelectbox.classList.remove('active');
    }
  });

  optionsContainer.addEventListener('click', function (e) {
    let optionElement;

    //TODO: Remove jQuery code
    if ($(e.target).hasClass('country-option')) {
      optionElement = e.target;
    } else {
      optionElement = $(e.target).parent('.country-option')[0];
    }

    if (optionElement) {
      var previous = document.querySelector('.option-selected');
      previous && previous.classList.contains('option-selected') && previous.classList.remove('option-selected');
      selectedOption = optionElement.querySelector('.radio');
      let selectedCountryCode = optionElement.querySelector('.radio').value;
      taxSelected.innerHTML = optionElement.querySelector('label').innerHTML;
      optionElement.className += ' option-selected';
      setState({user_country: selectedCountryCode});
      selectedCountryHiddenField.val(selectedCountryCode);
      taxSelectbox.classList.remove('active');
    }
  });

  countrySearch.addEventListener('keyup', function (e) {
    let res = '';

    allCountries.map(val => {
      if (val.country_name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
        res += `<div class="country-option ${selectedOption.value == val.iso2 ? 'option-selected' : ''}">
                        <input type="radio" class="radio" id="vat-${val.iso2}" name="Country" value="${val.iso2}">
                        <img loading="lazy" src="https://images.purevpn-tools.com/public/images/tickmark-dropdown.png" alt="" class="img-responsive img-selected">
                        <label for="${val.iso2}">${val.country_name}</label>
                    </div>`;
      }
    });

    optionsContainer.innerHTML = res;
  });
}

/* Render Components */
function renderComponents() {
  const OrderSummaryInstance = new OrderSummary();
  OrderSummaryInstance.render();

  const CheckoutFormInstance = new CheckoutForm();
  CheckoutFormInstance.render();

  GpayGateway.loadGooglePayIfApplicable();
  ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
}

const GatewaysInstance = new Gateways();
GatewaysInstance.render();

/* Official Apple Pay on the Web CTA: show the branded <apple-pay-button> (hide the purple
   #submit button) only while Apple Pay is the selected gateway. Clicking it reuses #submit's
   existing flow (validation, incentives, processCheckout -> applePay.begin()). */
(function initApplePayCta() {
  const applePayCta = document.getElementById('apple-pay-cta');
  const submitBtn = document.getElementById('submit');
  if (!applePayCta || !submitBtn) return;
  applePayCta.addEventListener('click', () => submitBtn.click());
  const syncCtaVisibility = () => {
    const isApplePay = store.state.cartState?.selected_gateway === 'applepay';
    applePayCta.style.display = isApplePay ? 'inline-block' : 'none';
    submitBtn.style.display = isApplePay ? 'none' : '';
  };
  store.events.subscribe('stateChange', syncCtaVisibility);
  syncCtaVisibility();
})();

const AddonsInstance = new Addons();
AddonsInstance.render();

const packageBoxesInstance = new PackageBoxes();
packageBoxesInstance.render();

const IncentiveInstance = new Incentive();
IncentiveInstance.render();

const GatewayIncentiveInstance = new GatewayIncentive();
GatewayIncentiveInstance.render();

const PlanBoxesInstance = new PlanBoxes();
PlanBoxesInstance.render();

const PopularAddonsInstance = new PopularAddons();
PopularAddonsInstance.render();

// Addons accordians
const addonsAccordionTitle = document.querySelector('.addons-accordion-title');
addonsAccordionTitle.addEventListener('click', function (e) {
  const siblingElement = addonsAccordionTitle?.nextElementSibling;

  addonsAccordionTitle.classList.toggle('active');
  siblingElement.classList.toggle('show');

  if (siblingElement.classList.contains('show')) {
    siblingElement.classList.add('addon-anim-exp');
    siblingElement.classList.remove('addon-anim-col');
  } else {
    siblingElement.classList.remove('addon-anim-exp');
    siblingElement.classList.add('addon-anim-col');
  }
});

function showVpnStripe() {
  const PopularAddonWrapper = document.querySelector('.popular-addons-box');
  PopularAddonWrapper?.classList.add('active');
}

showVpnStripe();
